import React from 'react'
import ProductsPage from './ProductsPage'

const Deals = () => {
  return <ProductsPage pageType="deals" />
}

export default Deals
